/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClientFromJSON, ApiClientToJSON, } from './ApiClient';
export function ApiListClientsResponseFromJSON(json) {
    return ApiListClientsResponseFromJSONTyped(json, false);
}
export function ApiListClientsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPageToken': !exists(json, 'nextPageToken') ? undefined : json['nextPageToken'],
        'results': !exists(json, 'results') ? undefined : (json['results'].map(ApiClientFromJSON)),
    };
}
export function ApiListClientsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPageToken': value.nextPageToken,
        'results': value.results === undefined ? undefined : (value.results.map(ApiClientToJSON)),
    };
}
